<template>
    <a class="btn btn-secondary" :href="route_back">Вернуться</a>
    <div>
        <div>
            <span class="fs-3">
                Контент плейлиста "{{item.name}}":
            </span>
            <div v-for="(content, index) in contents" class="card" style="width: 18rem;">
                <div v-if="content.active">
                    <img :src="content.path" class="card-img-top" alt="...">
                    <div class="card-body">
                        <h5 class="card-title">{{content.name}}</h5>
                        <a href="" class="btn btn-danger" v-on:click="deleteContent(index)">Удалить</a>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <span class="fs-3">
                Контент не добавленный:
            </span>
            <div v-for="(content, index) in contents" class="card" style="width: 18rem;">
                <div v-if="!content.active">
                    <img :src="content.path" class="card-img-top" alt="...">
                    <div class="card-body">
                        <h5 class="card-title">{{content.name}}</h5>
                        <a href="" class="btn btn-success" v-on:click="addContent(index)">Добавить</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Playlist from "../../../../models/Playlist";

export default {
    name: "PlaylistContentComponent",
    props: {
        route_back: String,
        route_get: String,
        route_content_add: String,
        route_content_del: String,
        item_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            playlist: new Playlist({
                route_get: this.route_get,
                route_content_del: this.route_content_del,
                route_content_add: this.route_content_add
            }),
            item: [],
            contents: []
        }
    },
    methods: {
        getData: async function () {
            let response = await this.playlist.get(this.item_id);
            this.item = response.playlist;
            this.contents = response.contents;
        },
        addContent: async function (index) {
            event.preventDefault();
            let result = await this.playlist.addContent(this.item_id, this.contents[index].id);
            if(result)
            {
                this.contents[index].active = true;
            }
            else
            {
                console.log('error: content_add');
            }
        },
        deleteContent: async function (index) {
            event.preventDefault();
            let result = await this.playlist.delContent(this.item_id, this.contents[index].id);
            if(result)
            {
                this.contents[index].active = false;
            }
            else
            {
                console.log('error: content_del');
            }
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style scoped>

</style>
